import { cloneDeep, set } from "lodash";

export function updateObjectKeyValue<T>(
  data: T,
  key: keyof T,
  value: string,
): T {
  const deepCopy = cloneDeep(data) as object;

  return set(deepCopy, key, value) as T;
}
